"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLAYER_CSS_CLASSNAME = void 0;
exports.PLAYER_CSS_CLASSNAME = '__remotion-player';